// extracted by css-extract-rspack-plugin
export default {"link":"_417dc84e"};